import React from 'react'

import style from './style.scss'

export default class TemplateModule extends React.Component {

  render() {
    return <h4>This module is empty...</h4>
  }
}



// WEBPACK FOOTER //
// ./src/views/index.jsx